import TheAutoReserveModal from '@components/ui/hotelPage&view/TheAutoReserveModal/TheAutoReserveModal.vue';
import TheOldAutoReserveModal from '@components/ui/hotelPage&view/TheOldAutoReserveModal.vue';

const useAutoReserveModal = () => {
    const autoReserveStore = useAutoReserveStore();
    const openAutoReserveModal = (eventName: string) => {
        useAnalyticsStore().trackPosthog(eventName);
        const { open } = useModal({
            component: autoReserveStore.oldFlowEnabled
                ? TheOldAutoReserveModal
                : TheAutoReserveModal,
            modalAttrs: {
                zIndexFn: () => 100000000,
            },
        });
        open();
    };
    return {
        openAutoReserveModal,
    };
};

export default useAutoReserveModal;
